import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';

import { mergeMap } from 'rxjs/operators';
import { Actions } from '../../actions';
import { ReplaceAsset, ReplaceAssetSuccess } from '../action-creators';
import { REPLACE_ASSET } from '../actions';
import { replace } from '@webapp/sdk/assets';

export const replaceAssetEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, ReplaceAsset>(REPLACE_ASSET),
    mergeMap(async (action) => {
      const response = await replace(
        action.assetId,
        action.assetType,
        action.file
      );

      return new ReplaceAssetSuccess(
        action.assetType,
        action.file.name,
        action.file.size,
        response,
        action.metadata,
        action.trackingId
      );
    })
  );
